export default {
  WX: "wx",
  YS: "ys",
  YP: "yp",
  WEB: 'web',
};
